// removed by extract-text-webpack-plugin
module.exports = {"footer":"_24e7Z-footer","default":"_1WSZA-default","material":"_3gSj1-material","ios":"_3V4CS-ios","logotype":"_3uQ6_-logotype","companies":"_4nWrv-companies","support":"_1ns7u-support"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/Footer/Footer.scss
// module id = 798
// module chunks = 0